var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cgform-auto-list-table',{attrs:{"url":{},"table":_vm.table,"isorter":_vm.isorter,"show-alert-bar":false,"buttonSwitch":{},"cgButtonLinkList":[],"currentTableName":"","checkboxFlag":false,"hasBpmStatus":false,"scrollFlag":0}})}
var staticRenderFns = []

export { render, staticRenderFns }